module.exports = __webpack_public_path__ + "img/dashboard-logo.85cd1bbd.svg";